export default {

    props: {
        name: {
            type: String,
            required: true,
        },
        breakout: {
            type: Boolean,
            default: false,
        },
        breakoutExtended: {
            type: Boolean,
            default: false,
        },
        buttonText: {
            type: String,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: null,
        },
    },

    computed: {

        titleOrName() {
            return this.title || this.name
        },
    },
}
